import { HideRejectedFeature } from 'feature/moderation/hide-rejected';
import { feature, demoFile } from 'system/demo';

demoFile('feature/moderation/hide-rejected');

feature('hide_rejected', {
    structureKey: 'question',
    state: {
        collections: {
            comment: [
                {key: 1, from: 'a', text: 'Pending', inReview: true}
            ]
        }
    }
});
